import React, { useMemo } from "react";
import { injectIntl } from "@edx/frontend-platform/i18n";
import { Button, ModalDialog, Image } from "@openedx/paragon";

import messages from "../messages";
import { ReactComponent as ConfirmIcon } from './svg/confirmation-icon.svg';


function ElectiveSubmitModal({
  intl,
  isOpen,
  handleCloseModal,
  minReqElectives,
  totalSelectedElectives,
}) {
  return (
    <ModalDialog
      isOpen={isOpen}
      title="Electives Selected"
      size="md"
      onClose={() => handleCloseModal()}
      variant="block"
      isFullscreenOnMobile
      className="elective-modal"
    >
      <ModalDialog.Header>
        <div className="text-center mb-3">
          <ConfirmIcon />
        </div>
        <ModalDialog.Title style={{ fontSize: '24px' }}>
          {intl.formatMessage(messages.electiveAfterSubmitDialogTitle)}
        </ModalDialog.Title>
      </ModalDialog.Header>
      <ModalDialog.Body className="mt-2">
        {intl.formatMessage(messages.electiveAfterSubmitDialogDescription, {
          minReqElectives,
          totalSelectedElectives,
          minReqElectivesNumber: minReqElectives,
        })}

        <div className="modal-cta d-flex justify-content-center">
          <Button variant="outline-primary" onClick={() => handleCloseModal()}>
            {intl.formatMessage(messages.electiveDialogClose)}
          </Button>
        </div>
      </ModalDialog.Body>
    </ModalDialog>
  );
}

export default injectIntl(ElectiveSubmitModal);
